// extracted by mini-css-extract-plugin
export var alignBaseline = "_e-9";
export var alignCenter = "_e-5";
export var alignFlexEnd = "_e-7";
export var alignFlexStart = "_e-6";
export var alignSelfBaseline = "_e-e";
export var alignSelfCenter = "_e-a";
export var alignSelfFlexEnd = "_e-c";
export var alignSelfFlexStart = "_e-b";
export var alignSelfStretch = "_e-d";
export var alignStretch = "_e-8";
export var column = "_e-2";
export var columnReverse = "_e-4";
export var flex = "_e-0";
export var justifyCenter = "_e-f";
export var justifyFlexEnd = "_e-h";
export var justifyFlexStart = "_e-g";
export var justifySpaceAround = "_e-j";
export var justifySpaceBetween = "_e-i";
export var justifySpaceEvenly = "_e-k";
export var row = "_e-1";
export var rowReverse = "_e-3";
export var wrapNowrap = "_e-m";
export var wrapWrap = "_e-l";
export var wrapWrapReverse = "_e-n";